module.exports = __webpack_public_path__ + "img/logo.f9a47740.png";